import { render, staticRenderFns } from "./UnbublishDialog.vue?vue&type=template&id=31531ca3"
import script from "./UnbublishDialog.vue?vue&type=script&lang=js"
export * from "./UnbublishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports